import {Grid, Step, StepLabel, Stepper} from "@mui/material";
import React, {useEffect, useState} from "react";
import {FormularioProcesado} from "../Hoc/FormularioProcesado";

export const usePasosFormularios = ({datos = {}, formularios = []}) => {
    const [paso, setPaso] = useState(0)
    const [datos_, setDatos_] = useState(datos)


    const siguiente = (e) => {


        if (formularios.length > paso + 1) {
            setDatos_(e)
            let pasoActual = paso
            pasoActual++
            setPaso(pasoActual)
        }
    }
    const anterior = () => {
        if (paso > 0) {
            let pasoActual = paso
            pasoActual--
            setPaso(pasoActual)
        }
    }

    const obtenerEntidad = async (e) => {
        return datos_
    }

    const obtenerFormularioActual = ({finalizar, cargando}) => {

        return <FormularioProcesado formulario={formularios[paso]} setDatos={setDatos_} anterior={anterior}
                                    siguiente={siguiente} paso={paso} datos={datos_} finalizar={finalizar}
                                    ultimo={formularios.length === paso + 1} cargando={cargando}/>

    }



    const Pasos = ({finalizar,cargando=false}) => {
        return (

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}>


                <Stepper activeStep={paso} sx={{width: '100%'}}>

                    {formularios.map((it) => {
                        return (
                            <Step key={'label'}>
                                <StepLabel sx={{paddingLeft: 1}}>{''}</StepLabel>
                            </Step>
                        )
                    })}

                </Stepper>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{minHeight: 100, marginBottom: 4, marginTop: 2}}>
                    {obtenerFormularioActual({finalizar: finalizar, cargando: cargando})}
                </Grid>


            </Grid>

        )
    }


    return {
        Pasos,
        obtenerEntidad,
    }


}